<div class="db-no-websites">
  <div class="grid">
    <!-- Card 1 -->
    <div class="card">
      <div class="card-image"></div>
      <div class="bar-dark"></div>
      <div class="bar-light"></div>
    </div>

    <!-- Card 2 with message -->
    <div class="card">
      <div class="card-image"></div>
      <div class="bar-dark"></div>
      <div class="bar-light"></div>
    </div>

    <!-- Card 3 -->
    <div class="card">
      <div class="card-image"></div>
      <div class="bar-dark"></div>
      <div class="bar-light"></div>
    </div>
  </div>

  <div class="message">
      @if (!loading) {
          <div @fadeIn>
              <div class="message-title">{{'text_noWebsitesYet' | dbText}}</div>
              <div class="message-subtitle mt8">{{'text_getStartedByGeneratingWebsite' | dbText}}</div>
          </div>
      } @else {
          <db-loading-screen [pageBlocker]="true"></db-loading-screen>
      }
  </div>
</div>

